import { createRouter, createWebHashHistory } from "vue-router";
import RoutesConfig from "./config"; // 导入子路由配置
import store from "../store/index";
import Login from "../views/Energy/Login.vue";
import logdata from "../views/Energy/logdata.vue"; // 示例路径，需对应实际文件
import Home from "../views/home.vue";//官网首页
import Official from "../views/Official.vue";//电脑版下载页
import Mobile from "../views/mobile.vue";//手机版下载页


// 主路由：仅定义根级路由（非嵌套路由）
const routes = [
   // 先合并 config.js 中的路由（重定向 / → /official、404）
  ...RoutesConfig, 
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/official",
    name: "official",
    component: Official,
  },
  {
    path: "/home",
    name: "home",
    component: Home
  },
  // {
  //   path: "/mobile",
  //   name: "mobile",
  //   component: Mobile
  // },
];

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 全局路由守卫：控制登录权限 + 动态挂载子路由
router.beforeEach((to, from, next) => {
  // 免登录页面直接放行

  if (to.name === "login" || to.name === "mcnaskfor" || to.path === "/official" || to.path === "/" || to.path === "/home" || to.path === "/mobile" || to.path === "/api" || to.path === "/about") {
    next();
  } else {
    // 未登录 → 跳登录页
    if (!localStorage.getItem("token")) {
      next({ path: "/login" });
    } else {
      // 未挂载子路由 → 动态挂载
      if (!store.state.isGetterRouter) {
        router.removeRoute("logdata"); // 先删除旧路由，避免重复
        ConfigRouter(); // 挂载子路由
        next({ path: to.fullPath }); // 重新跳转目标页
      } else {
        next(); // 已挂载 → 直接放行
      }
    }
  }
});

// 动态挂载子路由（核心：将 config.js 的路由添加为 mainbox 的子路由）
const ConfigRouter = () => {
  // 确保 mainbox 路由存在
  if (!router.hasRoute("logdata")) {
    router.addRoute({
      path: "/logdata",
      name: "logdata",
      component: logdata
    });
  }

  // 遍历子路由配置，直接添加（不再进行权限校验，移除 checkPermission 判断）
  RoutesConfig.forEach(item => {
    router.addRoute("logdata", item); // 直接挂载，无需权限过滤
  });

  // 标记子路由已挂载
  store.commit("changeGetterRouter", true);
};



export default router;